import { createMetaItem } from '@jane/bloom/resources/meta/createMetaVariables';
import type { CustomSEOPage } from '@jane/bloom/types/schemas/roots/bloom/customSEO';

import styles from './seoHeading.module.css';

interface SeoHeadingProps {
  customSEOPage: CustomSEOPage;
  defaultTitle: string;
  metaVariables: Record<string, string>;
}

export function SeoHeading({
  customSEOPage,
  defaultTitle,
  metaVariables,
}: SeoHeadingProps) {
  if (!metaVariables['storeName']) return null;

  const title = createMetaItem(
    !!customSEOPage?.title,
    metaVariables,
    customSEOPage?.title ?? '',
    defaultTitle
  );

  return <h1 className={styles['screenReaderOnly']}>{title}</h1>;
}
